import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { collaboration } from '../system/environment/Config.json'
import { RootState } from '../store'
import { MsalToken } from '../system/msal/MsalToken'
import { TotpSessionKey } from '../shared/Constants'

const fetchBaseCollaborationWrapperApiQuery = fetchBaseQuery({
  baseUrl: collaboration.api.baseurl,
  prepareHeaders: async (headers: Headers, api) => {
    const tokenResult = await MsalToken.getAccessToken([collaboration.api.scope])
    const state = api.getState() as RootState
    headers.append('Authorization', `${tokenResult.tokenType} ${tokenResult.accessToken}`)
    headers.append('Content-Type', 'application/json')
    headers.append('cache-control', 'no-cache')
    headers.append('version', 'v2')
    headers.append('profilejson', state.app.profileKey ?? '')
    headers.append('contextjson', state.app.contextKey ?? '')

    if (state.app.totpSessionKey) {
      headers.append(TotpSessionKey, state.app.totpSessionKey)
    }

    return headers
  }
})

const CollaborationWrapperApiSlice = createApi({
  reducerPath: '@api/collaborationWrapper',
  baseQuery: fetchBaseCollaborationWrapperApiQuery,
  endpoints: () => ({}),
  tagTypes: ['CollaborationItemList']
})

export default CollaborationWrapperApiSlice
